import React from 'react';
import {connect} from 'react-redux';
import { List, Button, Tooltip, message} from 'antd';
import { ScheduleOutlined } from '@ant-design/icons'
import { DcatCatalogs, AdmsRepository } from '../../redux';
import { LoadingComponent } from '../../utils/ui';
import Description from '../widgets/Description';
import i18n from "i18next";
import CatalogItem from './CatalogItem';

const count = 3;
  
//  см. https://ant.design/components/list/
class CatalogRepository extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      loading: false, 			//Флаг загрузки
    }
    this.onSelectedInList = this.onSelectedInList.bind(this);
  }
  
  componentDidMount() {
    const {state} = this.props;
    if (state=="empty")
      this.onLoadMore();
  }

  //вызывается только в случае передачи компоненту новых свойств
	//единственный метод ЖЦ компоненты, в котором может быть вызван метод setState;
	componentWillReceiveProps(nextProps){
    const {state, conditions} = nextProps;
    if (state=="empty")
      this.onLoadMore(true, conditions);
  }
    
  onSelectedInList (item) {
    const {onSelected, router} = this.props;
    if (onSelected) 
      onSelected(item.catalog.value, item.graph.value, AdmsRepository, router.navigate);
  }

  /** Метод начального считывания, когда offset=0. Разница в получении количества записей */
  loadFirst = (filter=null) => {
    const {conditions, lang} = this.props;
    this.props.dispatch(DcatCatalogs.loadCatalogs((filter)?filter:conditions))
      .then ((response) =>{
        const {head, results} = response[0];
        const {distinct, ordered, bindings} = results;
        this.setState({loading: false,}, () => { window.dispatchEvent(new Event('resize')); });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
  }
  /** Метод для досчитывания данных */
  onLoadMore = (reload=false, filter=null) => {
    //console.log("onLoadMore", reload, filter, this);
    this.setState({ loading: true });
    const {items, conditions, lang} = this.props;
    const offset = (!reload && items && Array.isArray(items))?items.length:0;
    if (offset==0){
      this.loadFirst(filter);
      return;
    }
    this.props.dispatch(DcatCatalogs.loadNextCatalogs(offset, (filter)?filter:conditions))
      .then ((response) =>{
        const {head, results} = response;
        const {distinct, ordered, bindings} = results;
        this.setState({
          loading: false,
        }, () => {
          // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
          // In real scene, you can using public method of react-virtualized:
          // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
          window.dispatchEvent(new Event('resize'));
        });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
    };
  
    render() {
      const { loading  } = this.state;
      const { items, count } = this.props;
      const loadMore = loading ? (
        <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px'}}><LoadingComponent /></div>
      ) : (
        ((items.length != count) && (count>0))?
        <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px', display1: 'none'}}>
          <Tooltip placement="top" title= {i18n.t('components.adms.repository_tooltip', {count: count, length:count-items.length})}>
            <Button onClick={() => this.onLoadMore()}>{i18n.t('components.adms.repository_load_next')}</Button>
          </Tooltip>
        </div>
        : null
      );
      //console.log(this);
      return (
        <List
          className="demo-loadmore-list adms_category_div csi_spoiler active"
          loading={loading}
          itemLayout="horizontal"
          loadMore={loadMore}
          dataSource={items}
          renderItem={item => (
            <List.Item actions={[]} style={{padding: 0}}>
              <CatalogItem 
                catalog={item.catalog.value} 
                graph={item.graph.value} 
                factory={this.props.factory}
                onDeleted={() => this.loadFirst()}
                onClick={()=> this.onSelectedInList(item)} />
            </List.Item>
          )}
        />
      );
    }
  }
  
  function mapStateToProps(state, props) {
    return {
        ...state.vcatalogs
    };
  }
  
  export default connect(mapStateToProps)(CatalogRepository);